import vSelect from "vue-select";

export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	components: {
		"v-select": vSelect,
	},

	mounted() {

	},

	data() {
		return {

		};
	},

	computed: {

	},

	methods: {
		onClose: function () {
			this.context.blurHandler();
		},

		onSearch: function(val, loading) {
			if(val.length) {
				loading(true)
				this.$emit('search', {loading, val});
			} else {
				loading(false)
				let emptyArray = []
				this.$emit('search', {loading, emptyArray})
			}
		}
	},
};
